import {Component, OnInit} from '@angular/core';
import { AnagraficaClientiResponse } from 'src/app/entities/AnagraficaClientiResponse';
import { Clienti } from 'src/app/entities/clienti';
import { ApiService } from 'src/app/services/api.service';
import { SecurityApiService } from 'src/app/services/security-api.service';
import {UtilityService} from "../../services/utility.service";
import { MenuService } from 'src/app/services/menu-service';

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.css'],
    standalone: false
})
export class PageHeaderComponent implements OnInit{

  constructor(
                private api: ApiService,
                private securityApi: SecurityApiService,
                private utility: UtilityService,
                private menuService: MenuService){
  }

  SociArray = new Array<Clienti>();
  CodiceSocio = '';
  SocioSelezionato = '';
  NomeUtente = '';
  errorMessage = '';

  async ngOnInit(): Promise<void> {

    const token = this.utility.GetSecurityToken();
    if(!token || token == '')
    {
      return; // User is not logged in
    }

    await this.loadingStaticData();
    {
      const result = await this.securityApi.GetUserName();
      if (result) {
        if (result.success && !result.error) {
          this.NomeUtente = result.userName;
        } else {
          this.NomeUtente = result.errorMessage;
        }
      } else {
        this.errorMessage = 'Si è verificato un errore durante la richiesta.';
      }
    }
  }

  async loadingStaticData() {
    try {
      // Attendere la risposta principale dell'API
      const getAnagraficaSociPromise = this.api.GetAnagraficaSociGetSingle();
      const getImagePromise = fetch('assets/img/LogoTop.png').then(response => response.blob());

      // Attendere entrambe le promesse
      const [anagraficaSociResponse, imageBlob] = await Promise.all([getAnagraficaSociPromise, getImagePromise]);

      // Gestire la risposta dell'API
      this.ManageGetAnagraficaSociResponse(anagraficaSociResponse);

      // Gestire l'immagine
      const reader = new FileReader();
      reader.onload = () => {
        const dataURL = reader.result as string;
        // Usa dataURL come necessario
      };
      reader.readAsDataURL(imageBlob);

    } catch (error) {
      if (error instanceof Error) {
        // Gestire errori specifici, come quelli relativi all'API
        // console.error('Errore:', error.message);
        if (error.message.includes('403')) {
          const errorResponse: AnagraficaClientiResponse = {
            success: false,
            message: 'Accesso negato. Effettua l\'accesso corretto.',
            sociList: []
          };
          this.ManageGetAnagraficaSociResponse(errorResponse);
        } else {
          // console.error('Errore non gestito:', error);
        }
      } else {
        // console.error('Errore sconosciuto:', error);
      }
    }
  }

  async ManageGetAnagraficaSociResponse(response: AnagraficaClientiResponse) {
    this.SociArray = response.sociList;
    if(this.SociArray.length > 0)
    {
      this.CodiceSocio = this.SociArray[0].codiceSocio;
      this.SocioSelezionato = this.SociArray[0].descrizioneSocio;
    }
  }

  setActiveMenuName(menuName: string): void {
    this.menuService.SetActiveMenuName(menuName);
    this.menuService.StopLoadingInProgressScreen(); //this is added so that any component subscribed to this.menuService.loadingStatusChanged
                                                    //can detect the page being loaded (Home) is not itself and has a chance to cleanup (e.g. stop polling)
  }
}
